module.exports = __webpack_public_path__ + "static/media/29COICT4.d0b99cb9.jpg";